module.exports = __webpack_public_path__ + "img/pic15.4dfea9b6.png";